function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from "react";
var SearchFieldSuggestions = /*#__PURE__*/function (_React$Component) {
  function SearchFieldSuggestions(props) {
    var _this;
    _classCallCheck(this, SearchFieldSuggestions);
    _this = _callSuper(this, SearchFieldSuggestions, [props]);
    _this.state = {
      suggestions: [],
      filteredSuggestions: []
    };
    return _this;
  }
  _inherits(SearchFieldSuggestions, _React$Component);
  return _createClass(SearchFieldSuggestions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var filteredData = this.props.filters.concat(this.props.contentTypes).map(function (item) {
        return item.name;
      }).sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
      var suggestions = _toConsumableArray(new Set(filteredData));
      this.setState({
        suggestions: suggestions
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        searchQuery = _this$props.searchQuery,
        showSuggestions = _this$props.showSuggestions;
      if (prevProps.searchQuery !== searchQuery || prevProps.showSuggestions !== showSuggestions) {
        var filteredSuggestions = searchQuery.length && showSuggestions ? this.state.suggestions.filter(function (suggestion) {
          return suggestion.toLowerCase().includes(searchQuery.toLowerCase());
        }) : [];
        this.setState({
          filteredSuggestions: filteredSuggestions
        });
      }
    }
  }, {
    key: "onSuggestionClick",
    value: function onSuggestionClick(suggestion) {
      if (suggestion !== this.props.searchQuery) {
        this.props.handleSearch(suggestion, true, "suggestions_dropdown");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var filteredSuggestions = this.state.filteredSuggestions;
      return /*#__PURE__*/React.createElement(React.Fragment, null, filteredSuggestions.length > 0 && /*#__PURE__*/React.createElement("ul", {
        className: "resource-center__search__field__suggestions"
      }, filteredSuggestions.map(function (suggestion, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: suggestion + index,
          onClick: function onClick() {
            _this2.onSuggestionClick(suggestion);
          }
        }, suggestion);
      })));
    }
  }]);
}(React.Component);
export default SearchFieldSuggestions;